import { useState } from "react";
import { X } from "lucide-react";

/**
 * GenresInput — input de chips para géneros musicales. Enter o coma agrega;
 * Backspace con el input vacío quita el último. Dedupe case-insensitive +
 * tope `max`. Compartido entre el modal de alta y el editor de ficha.
 */
export function GenresInput({
  value,
  onChange,
  max = 12,
  placeholder = "Techno, House… (Enter o coma para agregar)",
}: {
  value: string[];
  onChange: (next: string[]) => void;
  max?: number;
  placeholder?: string;
}) {
  const [input, setInput] = useState("");

  const add = (raw: string) => {
    const g = raw.trim();
    if (!g) return;
    if (value.length >= max) return;
    if (value.some((x) => x.toLowerCase() === g.toLowerCase())) {
      setInput("");
      return;
    }
    onChange([...value, g]);
    setInput("");
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      add(input);
    } else if (e.key === "Backspace" && !input && value.length) {
      onChange(value.slice(0, -1));
    }
  };

  return (
    <div>
      {value.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mb-2">
          {value.map((g) => (
            <span
              key={g}
              className="nx-badge bg-accent-soft text-accent inline-flex items-center gap-1"
            >
              {g}
              <button
                type="button"
                onClick={() => onChange(value.filter((x) => x !== g))}
                className="hover:text-fg"
                aria-label={`Quitar ${g}`}
              >
                <X size={10} />
              </button>
            </span>
          ))}
        </div>
      )}
      <input
        type="text"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={handleKeyDown}
        onBlur={() => input.trim() && add(input)}
        placeholder={placeholder}
        className="nx-input w-full"
        disabled={value.length >= max}
      />
    </div>
  );
}
